import React, {forwardRef} from 'react';
import BasicTextAreaInput from './BasicTextAreaInput';
import { TextInput } from '@unthinkable/react-text-input';

const TextAreaInput = forwardRef((props, ref) => {
  return <TextInput {...props} ref={ref} as={BasicTextAreaInput} />;
});

export default TextAreaInput;
